import React from 'react';
import {
  Button,
  CssBaseline,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';

import Stack from '@mui/material/Stack';
import SubTitle from '../components/Text/SubTitle';

import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
// import CardHeader from '@mui/material/CardHeader';
// import CardActions from '@mui/material/CardActions';

const styles = (theme) => ({
  message: {
    padding: theme.spacing(2, 0, 5),
    color: '#555',
    textAlign: 'justifyContent',
    '& p': {
      marginBottom: '1.2em',
    },
  },
  divLine: {
    width: '100%',
    height: '1px',
    margin: theme.spacing(7, 0),
    backgroundColor: 'rgba(0,0,0,0.1)',
  },

  stepsDiv: {
    display: 'flex',
    width: '100%',
  },
  stepItem: {
    width: '33%',
  },
  stepsNo: {
    fontSize: '1.4em',
    color: '#7d889a',
    '& span': {
      fontSize: '1.4em',
      fontWeight: 'bold',
    },
  },
  stepContent: {
    padding: theme.spacing(3, 4),
    fontSize: '1.2em',
    color: '#fff',
    height: '140px',
    textAlign: 'center',
    wordBreak: 'kepp-all',
  },

  orderedList: {
    '& li': { marginBottom: '.5rem', fontWeight: 500, fontSize: '1.2em', lineHeight: 1.8 },
    // '& span': {
    //   color: 'red',
    //   fontWeight: 'bold',
    // },
  },
});

const StyledTitleCell = withStyles((theme) => ({
  root: {
    backgroundColor: '#e9eef1',
    borderTop: '2px solid #237a9d',
    fontSize: '1.2em',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 8,
  },
}))(TableCell);

const StyledContentTitleCell = withStyles((theme) => ({
  root: {
    backgroundColor: '#e9eef1',
    fontSize: '1.2em',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 8,
  },
}))(TableCell);

const StyledContentCell = withStyles((theme) => ({
  root: {
    backgroundColor: '#ffffff',
    border: '2px solid #e9eef1',
    fontSize: '1.2em',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 8,
  },
}))(TableCell);

class Accommodation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:992px)').matches,
    };
  }

  componentDidMount() {}

  registrationProcess() {
    const { classes } = this.props;
    const STEPS = [
      {
        no: 1,
        color: '#7d889a',
        bgColor: 'rgba(125,136,154, 0.1)',
        title: 'STEP 01',
        content: 'Choose from different accommodation options to suit your budget',
      },
      {
        no: 2,
        color: '#265c7a',
        bgColor: 'rgba(38, 92, 122, 0.1)',
        title: 'STEP 02',
        content: 'Download and fill out the reservation form',
      },
      {
        no: 3,
        color: '#0c7282',
        bgColor: 'rgba(12,114,130, 0.1)',
        title: 'STEP 03',
        content: 'Send the completed reservation form directly to the hotel by E-mail',
      },
    ];

    return (
      <div className={classes.stepsDiv}>
        {STEPS.map((step, idx) => (
          <div key={`step-for-submission-${idx}`} className={classes.stepItem}>
            <div
              className={classes.stepsNo}
              style={{
                backgroundColor: step.bgColor,
                position: 'relative',
                padding: this.props.theme.spacing(2, 0),
                display: 'flex',
                alignItems: 'baseline',
              }}
              id={`steps-no-${idx + 1}`}
            >
              <p style={{ backgroundColor: step.color, width: '1em', height: '0.3em', position: 'absolute', bottom: '20%', left: 0 }} />
              <div style={{ marginLeft: 20 }}>
                Step <span style={{ color: step.color }}>0{idx + 1}</span>
              </div>
            </div>
            <div
              className={classes.stepContent}
              style={{ backgroundColor: step.color, height: 'auto !important' }}
              id={`steps-content-${idx + 1}`}
            >
              <Typography
                dangerouslySetInnerHTML={{
                  __html: step.content,
                }}
                style={{ fontSize: '1.1em', marginTop: '0.5em' }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }
  renderHotelInfo() {
    const HOTEL_INFO = [
      {
        no: 0,
        hotelName: 'GRAND INTERCONTINENTAL SEOUL PARNAS',
        hotelImg: 'hotel_img_01.png',
        managerName: 'Yuna Lee',
        tel: '02-559-7716',
        email: 'ic-convention@parnas.co.kr',
        homePage: 'https://seoul.intercontinental.com/grandicparnas',
        doc: 'parnas',
        chkIn: '15:00',
        chkOut: '11:00',
        deadLine: 7,
        roomInfo: [
          {
            type: 'Classic Room',
            rates: '290,000 KRW',
            capacity: '2 / MAX 3',
            room: 'room_00_a.png',
          },
        ],
      },

      // {
      //   no: 1,
      //   hotelName: 'InterContinental Seoul COEX',
      //   hotelImg: 'intercontinental_img.png',
      //   managerName: 'Yuna Lee',
      //   tel: '02-559-7716',
      //   email: 'ic-convention@parnas.co.kr',
      //   homePage: 'https://seoul.intercontinental.com/iccoex',
      //   doc: 'InterContinental',
      //   chkIn: '15:00',
      //   chkOut: '11:00',
      //   deadLine: 7,
      //   roomInfo: [
      //     {
      //       type: 'Classic Room',
      //       rates: '220,000 KRW',
      //       capacity: '2 / MAX 2',
      //       room: 'intercontinental_room.png',
      //     },
      //   ],
      // },
      {
        no: 2,
        hotelName: 'GLAD HOTELS & RESORTS',
        hotelImg: 'hotel_img_02.png',
        managerName: 'Han Se Ok',
        tel: '02-6222-5226',
        email: 'rsvn.coexcenter@glad-hotels.com',
        homePage: 'https://www.glad-hotels.com',
        doc: 'glad-hotels',
        chkIn: '15:00',
        chkOut: '12:00',
        deadLine: 3,
        roomInfo: [
          {
            type: 'Standard Double',
            rates: '143,000 KRW',
            capacity: '2 / MAX 2',
            room: 'room_01_a.jpg',
          },
          {
            type: 'Standard Twin',
            rates: '143,000 KRW',
            capacity: '2 / MAX 2',
            room: 'room_01_b.jpg',
          },
        ],
      },

      {
        no: 3,
        hotelName: 'Hotel PEYTO Samseong',
        hotelImg: 'hotel_img_03.png',
        managerName: 'Lisa Baek',
        tel: '02-6936-9991',
        email: 'reservations@peytohotel.com',
        homePage: 'https://www.peytohotel.com',
        doc: 'peytohotel',
        chkIn: '15:00',
        chkOut: '12:00',
        deadLine: 3,
        roomInfo: [
          {
            type: 'Superior Single',
            rates: '90,000 KRW',
            capacity: '1 / MAX 1',
            room: 'room_02_a.png',
          },
          {
            type: 'Deluxe Double / Twin',
            rates: '110,000 KRW',
            capacity: '2 / MAX 2',
            room: 'room_02_b.png',
          },
          {
            type: 'Urban Double',
            rates: '120,000 KRW',
            capacity: '2 / MAX 2',
            room: 'room_02_c.png',
          },
        ],
      },

      {
        no: 4,
        hotelName: 'URI& Hotel',
        hotelImg: 'hotel_img_04.png',
        managerName: 'James Park',
        tel: '02-500-2300',
        email: 'rsvn@uri-nhotel.com',
        homePage: 'http://www.uri-nhotel.com',
        doc: 'uri-nhotel',
        chkIn: '14:00',
        chkOut: '12:00',
        deadLine: 1,
        roomInfo: [
          {
            type: 'Superior Double / Twin',
            rates: '100,000 KRW',
            capacity: '2 / MAX 2',
            room: 'room_03_a.png',
          },
          {
            type: 'Deluxe Double / Twin',
            rates: '140,000 KRW',
            capacity: '2 / MAX 2',
            room: 'room_03_b.png',
          },
        ],
      },

      {
        no: 5,
        hotelName: 'Oakwood Premier Coex',
        hotelImg: 'oakwood.png',
        managerName: 'Joo Sub Yun',
        tel: '02-3466-7103',
        email: 'reservations.opcc@oakwoodpremier.co.kr',
        homePage: 'https://oakwoodpremier.co.kr/front/en/opcc#',
        doc: 'Oakwood',
        chkIn: '15:00',
        chkOut: '11:00',
        deadLine: 3,
        roomInfo: [
          {
            type: 'Studio Superior',
            rates: '230,000 KRW',
            capacity: '2 / MAX 2',
            room: 'oakwood_room_01.png',
          },
          {
            type: 'Studio Premier',
            rates: '255,000 KRW',
            capacity: '2 / MAX 2',
            room: 'oakwood_room_02.png',
          },
          {
            type: 'One Bedroom Superior',
            rates: '295,000 KRW',
            capacity: '2 / MAX 2',
            room: 'oakwood_room_03.png',
          },
        ],
      },

      {
        no: 6,
        hotelName: 'Ibis Ambassador Seoul Gangnam',
        hotelImg: 'ibis.png',
        managerName: 'Park Da Ram',
        tel: '02-3011-8888',
        email: 'stylegres@ambatel.com',
        homePage: 'https://www.ambatel.com/ibisstyles/gangnam/ko/main.do',
        doc: 'ibis',
        chkIn: '14:00',
        chkOut: '12:00',
        deadLine: 1,
        roomInfo: [
          {
            type: 'Superior Room<br/>(Double / Twin)',
            rates: '110,000 KRW',
            capacity: '2 / MAX 2',
            room: 'ibis_room_01.png',
          },
        ],
      },
    ];

    return (
      <Grid container>
        {HOTEL_INFO.map((hotel, idx) => (
          <Grid container key={idx} style={{ paddingBottom: 36 }}>
            <SubTitle>{hotel.hotelName}</SubTitle>
            <Grid container>
              <Card style={{ width: '100%' }}>
                <Stack direction={'row'}>
                  <CardMedia
                    component="img"
                    sx={{ width: 'auto', maxHeight: 300, borderRadius: '5px' }}
                    image={`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/info/${hotel.hotelImg}`}
                    alt=""
                  />
                  <CardContent style={{ width: '100%' }}>
                    <Stack alignItems="center" spacing={1}>
                      <Grid container alignItems="center">
                        {/* <Grid container justifyContent="flex-start">
                          <Typography style={{ fontSize: '1.6em', fontWeight: 'bold', color: '#555555', textAlign: 'flex-start' }}>
                            {hotel.hotelName}
                          </Typography>
                        </Grid> */}
                        <ul style={{ fontSize: '1.2em', lineHeight: 1.6, margin: '10px 0 10px 0' }}>
                          <li>Hotel Name&nbsp;:&nbsp;{hotel.hotelName}</li>
                          <li>Manager&nbsp;:&nbsp;{hotel.managerName}</li>
                          <li>TEL&nbsp;:&nbsp;{hotel.tel}</li>
                          <li>
                            E-mail&nbsp;:&nbsp; <a href={`mailto:${hotel.email}`}> {hotel.email}</a>
                          </li>
                          <li>
                            Homepage&nbsp;:&nbsp;
                            <u
                              onClick={() => {
                                window.open(`${hotel.homePage}`);
                              }}
                              style={{ cursor: 'pointer', color: 'blue' }}
                            >
                              {hotel.homePage}
                            </u>
                          </li>
                        </ul>
                      </Grid>

                      <Grid container justifyContent="flex-start" alignItems="center" item xs={12}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="primary"
                          size="large"
                          onClick={() => {
                            window.open(
                              `https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/info/reservation_form_${hotel.doc}.docx`,
                              '_blank',
                            );
                          }}
                          style={{ width: '380px', fontWeight: 'bold', marginLeft: 40, marginBottom: 10 }}
                          // style={{ color: '#fff', width: '98%' }}
                        >
                          Reservation Form Download
                        </Button>
                      </Grid>
                      <Grid container justifyContent="flex-start" alignItems="center" item xs={12}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="secondary"
                          size="large"
                          onClick={() => {
                            window.open(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/info/guideline_${hotel.doc}.pdf`, '_blank');
                          }}
                          style={{ color: '#fff', width: '380px', fontWeight: 'bold', marginLeft: 40 }}
                        >
                          Hotel Guideline
                        </Button>
                      </Grid>
                    </Stack>
                  </CardContent>
                </Stack>
              </Card>
            </Grid>

            <Grid container>
              <Typography style={{ fontSize: '1.4em', fontWeight: 'bold', padding: this.state.matches ? '16px 0 8px' : '24px 0 12px' }}>
                Room Rates
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledTitleCell width={'20%'}>Room Type</StyledTitleCell>
                      <StyledTitleCell width={'20%'}>Rates</StyledTitleCell>
                      <StyledTitleCell width={'20%'}>Capacity</StyledTitleCell>
                      <StyledTitleCell width={'40%'}>Photo</StyledTitleCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {hotel.roomInfo &&
                      hotel.roomInfo.map((datas, ridx) => {
                        return (
                          <TableRow key={ridx}>
                            <StyledContentTitleCell>
                              <Typography
                                dangerouslySetInnerHTML={{
                                  __html: datas.type,
                                }}
                                style={{ fontWeight: 'bold', fontSize: '16.8px' }}
                              />
                            </StyledContentTitleCell>
                            <StyledContentCell>
                              <Typography
                                dangerouslySetInnerHTML={{
                                  __html: datas.rates,
                                }}
                                style={{ fontSize: '16.8px' }}
                              />
                            </StyledContentCell>
                            <StyledContentCell>
                              <Typography
                                dangerouslySetInnerHTML={{
                                  __html: datas.capacity,
                                }}
                                style={{ fontSize: '16.8px' }}
                              />
                            </StyledContentCell>
                            <StyledContentCell>
                              <img
                                src={`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/info/${datas.room}`}
                                alt=""
                                style={{ width: 400, height: 190 }}
                              />
                            </StyledContentCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Stack style={{ paddingTop: this.state.matches ? 8 : 24 }}>
              <Typography style={{ fontSize: this.state.matches ? 'large' : 'large' }}>
                <b>Check-in:</b> &nbsp;{hotel.chkIn}&nbsp;&nbsp;
                <b>Check-out:</b> &nbsp;{hotel.chkOut}
              </Typography>
              <Typography style={{ fontSize: this.state.matches ? 'large' : 'large' }}>
                <b>Reservation Deadline:</b> Free cancellation is possible&nbsp;
                <b style={{ color: '#f00' }}>
                  {hotel.deadLine}&nbsp;{hotel.deadLine === 1 ? 'day' : 'days'}
                </b>
                &nbsp;before the visit.
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    );
  }

  render() {
    const { classes } = this.props;
    const Content_padding = 24;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={7} SIdx={3} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid container item xs={11} sm={10} md={9} lg={8}>
              <MainTitle>Accommodation</MainTitle>

              <Grid container direction="row" alignItems="center">
                <Grid container alignItems="center" style={{ paddingBottom: Content_padding }}>
                  <SubTitle>Reservation Process</SubTitle>
                  {this.registrationProcess()}
                </Grid>
                <Grid container style={{ paddingBottom: Content_padding }}>
                  <SubTitle>Notice</SubTitle>
                  <Grid container>
                    <div style={{ color: '#000000' }}>
                      <ol className={classes.orderedList}>
                        <li>
                          Under the room rates are standard by
                          <span style={{ color: '#f00' }}> 1 day</span>.{/* <b style={{ color: theme.palette.primary.main }}> 1 day</b>. */}
                        </li>
                        <li>
                          Please refer to the <span style={{ color: '#f00' }}>cancellation rules</span> of each hotel for cancellation.
                        </li>
                        <li>
                          The below reservation is the <span style={{ color: '#f00' }}>discount amount</span> during the PRS 2022.
                        </li>
                        <li>
                          Please refer to the
                          <span style={{ color: '#f00' }}>deadline for booking rooms </span> by Hotel.
                          <br />
                          (Please understand that the room may be closed early even before the deadline.)
                        </li>
                      </ol>
                    </div>
                  </Grid>
                </Grid>
                <Grid container style={{ paddingBottom: Content_padding }}>
                  {this.renderHotelInfo()}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Accommodation);
